import { createRouter, createWebHashHistory } from 'vue-router'
import storage  from "../store";



const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "login" */ '../components/ClaimForm.vue')
  },
  {
    path: '/generator',
    name: 'Generator',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "generator" */ '../views/Generator.vue'),
    beforeEnter: (to, from, next) => {
      if (!storage.getters.has_token) return next({name: 'Login'})
      return next()
    }
  },
  {
    path: '/generator/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),

  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
